import { render, staticRenderFns } from "./FileForm.vue?vue&type=template&id=3d503eea&"
import script from "./FileForm.vue?vue&type=script&lang=js&"
export * from "./FileForm.vue?vue&type=script&lang=js&"
import style0 from "./FileForm.vue?vue&type=style&index=0&scooped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
